import React from 'react';
import { EditEducationHistoryModal } from './edit-education-history-modal.component';
import { useEditEducationHistoryModalService } from './edit-education-history-modal.service';
import type { EditEducationHistoryModalContainerProps } from './edit-education-history-modal.types';

export const EditEducationHistoryModalContainer = (
  props: EditEducationHistoryModalContainerProps,
) => {
  const serviceProps = useEditEducationHistoryModalService(props);
  return <EditEducationHistoryModal {...serviceProps} />;
};
